import { useEffect, useState } from 'react'
interface State {
  previousStepIndex: undefined | number
  currentStepIndex: number
}

type UseAddAgentCurrentStepIndex = (params: {
  currentStepIndex: number
  onUpdate: () => void
}) => UseAddAgentCurrentStepIndexResponse

export type UseAddAgentCurrentStepIndexResponse = Pick<
  State,
  'previousStepIndex' | 'currentStepIndex'
> & {
  previousStep: () => void
  nextStep: () => void
  updateCurrentStepIndex: (newIndex: number) => void
  reset: (newCurrentStepIndex: number) => void
}

export const useAddAgentCurrentStepIndex: UseAddAgentCurrentStepIndex = ({
  currentStepIndex,
  onUpdate
}) => {
  const [state, setState] = useState<State>({
    previousStepIndex: undefined,
    currentStepIndex
  })

  const previousStep = () => {
    setState({
      ...state,
      previousStepIndex: state.currentStepIndex,
      currentStepIndex: state.currentStepIndex - 1
    })
  }
  const nextStep = () => {
    setState({
      ...state,
      previousStepIndex: state.currentStepIndex,
      currentStepIndex: state.currentStepIndex + 1
    })
  }
  const updateCurrentStepIndex = (newIndex: number) => {
    setState({
      ...state,
      previousStepIndex: state.currentStepIndex,
      currentStepIndex: newIndex
    })
  }

  useEffect(() => {
    onUpdate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.currentStepIndex])

  return {
    previousStepIndex: state.previousStepIndex,
    currentStepIndex: state.currentStepIndex,
    previousStep,
    nextStep,
    updateCurrentStepIndex,
    reset: (newCurrentStepIndex: number) =>
      setState({
        previousStepIndex: undefined,
        currentStepIndex: newCurrentStepIndex
      })
  }
}
